import { render, staticRenderFns } from "./CampaignStatusDialog.vue?vue&type=template&id=0cc966e5&"
import script from "./CampaignStatusDialog.vue?vue&type=script&lang=ts&"
export * from "./CampaignStatusDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports